// extracted by mini-css-extract-plugin
export var text = "_3x-0";